import React, { useEffect, useRef } from 'react'
import Title from '../../components/Title/Title'
import '../pages.css'
import styles from './Services.module.scss'
import ProgressiveImage from '../../components/ProgressiveImage/ProgressiveImage'
import {sliderFirstData} from '../Main/arrImages'
import {childrensHaircuts, hotBotox, womensHaircuts, cauterization, hairstyles, keratinSmoothing, intensiveRecovery, coldBotox, mensHaircuts, dyeing, pedicureWithCoating, modeling, varnishCoating, perm, eveningMakeup} from './arrServiceImages'

const Services = () => {
  const servicesRef = useRef(null)

  useEffect(() => {
    const detailsElements = servicesRef.current?.querySelectorAll('details') || []
    const animations = new Set()

    const cleanups = Array.from(detailsElements).map((details) => {
      const summary = details.querySelector('summary')
      const content = details.querySelector(`.${styles.detailsItems}`)

      if (!summary || !content) return () => {}

      const handleClick = (event) => {
        event.preventDefault()

        if (details.dataset.animating === 'true') return

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          details.open = !details.open
          return
        }

        details.dataset.animating = 'true'

        const isClosing = details.open

        if (!isClosing) details.open = true

        const expandedHeight = content.getBoundingClientRect().height

        if (isClosing) details.dataset.closing = 'true'

        const animation = content.animate(
          isClosing
            ? [
                { height: `${expandedHeight}px`, opacity: 1, transform: 'translateY(0)' },
                { height: '0px', opacity: 0, transform: 'translateY(-10px)' },
              ]
            : [
                { opacity: 0, transform: 'translateY(-10px)' },
                { opacity: 1, transform: 'translateY(0)' },
              ],
          { duration: isClosing ? 350 : 500, easing: 'ease-in-out' },
        )

        animations.add(animation)
        animation.finished
          .then(() => {
            if (isClosing) details.open = false
          })
          .catch(() => {})
          .finally(() => {
            animations.delete(animation)
            delete details.dataset.animating
            delete details.dataset.closing
          })
      }

      summary.addEventListener('click', handleClick)
      return () => summary.removeEventListener('click', handleClick)
    })

    return () => {
      cleanups.forEach((cleanup) => cleanup())
      animations.forEach((animation) => animation.cancel())
    }
  }, [])

  return (
    <div className="page-container" id='services'>
      <Title name='Наші послуги'/>
      <div className={styles.variousContent} ref={servicesRef}>
        <section id="heirdo">
          <h2 className="sectionTitle">Перукарські послуги</h2>
          <div className={styles.content}>
            <ProgressiveImage wrapperClassName={styles.contentImageFrame} src={sliderFirstData[0].image} width={sliderFirstData[0].width} height={sliderFirstData[0].height} alt={sliderFirstData[0].title}/>
            <div className={styles.contentDetails}>
              <details>
                <summary>Дитячі стрижки</summary>
                <div className={styles.detailsItems}>
                  {childrensHaircuts.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Дитячі стрижки – це окремий вид перукарського мистецтва.
                    Майстер повинен бути не тільки професіоналом, а й тонким психологом,
                    аби знайти особливий підхід до маленького клієнту.
                    Адже якщо за волоссям правильно доглядати з самого дитинства,
                     вони будуть сильними та здоровими протягом усього життя.</p>
                </div>
              </details>
              <details>
                <summary>Гарячий ботокс</summary>
                <div className={styles.detailsItems}>
                  {hotBotox.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Гарячий ботокс призначений для тих, кого крім оздоровлення цікавить
                     ще й випрямлення кучерявих, неслухняних, пухнастих пасм. 
                     Після процедури волосся стає рівним і гладким, майже як після кератинового випрямлення.</p>
                </div>
              </details>
              <details>
                <summary>Жіночі стрижки</summary>
                <div className={styles.detailsItems}>
                  {womensHaircuts.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Зачіска – це один із тих «трьох китів», що створюють неповторний, елегантний,
                     чарівний образ жінки. Допомогти знайти «ту саму себе», втілити мрію у реальність
                      – завдання для майстра гребінців і ножиць у Нії</p>
                </div>
              </details>
              <details>
                <summary>Каутеризація</summary>
                <div className={styles.detailsItems}>
                  {cauterization.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Це лікувально-естетична процедура, метою якої, перш за все, 
                    є відновлення пошкодженої структури, глибоке харчування і 
                    «запечатування» кутикули кожної волосинки. Якщо сказати по-науковому, 
                    каутеризація займається реструктуризацією волосся.</p>
                </div>
              </details>
              <details>
                <summary>Зачіски</summary>
                <div className={styles.detailsItems}>
                  {hairstyles.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Зачіска – це фінальний штрих усього образу. Вона повинна бути індивідуальною,
                     неповторною, а ще - зручною та гармонійною. Ми підбираємо зачіску під гостя
                      і його індивідуальні собливості. Ми маємо на меті підкреслити натуральну
                       красу та природність вашого волосся.</p>
                </div>
              </details>
              <details>
                <summary>Кератинове вирівнювання</summary>
                <div className={styles.detailsItems}>
                  {keratinSmoothing.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Це складна процедура, яка виконується за допомогою багатокомпонентних
                     професійних засобів. Ефект від кератинування помітний відразу і
                      зберігається протягом тривалого часу. Майстри нашого салону
                       готові зробити ваше волосся слухняним і м'яким. Запишіться на процедуру,
                        аби залишити норовливі кучері в минулому.</p>
                </div>
              </details>
              <details>
                <summary>Інтенсивне відновлення</summary>
                <div className={styles.detailsItems}>
                  {intensiveRecovery.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p></p>
                </div>
              </details>
              <details>
                <summary>Холодний ботокс</summary>
                <div className={styles.detailsItems}>
                  {coldBotox.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Холодний ботокс - це щадна процедура по оздоровленню кутикулярного шару волосся.
                     Її головна особливість полягає в технології без використання гарячого прасування,
                      тому процедура підходить навіть самим ушкодженому волоссю.</p>
                </div>
              </details>
              <details>
                <summary>Чоловічі стрижки</summary>
                <div className={styles.detailsItems}>
                  {mensHaircuts.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Красиві чоловіки завжди в тренді, а 
                    хіба можливий цілісний образ сильного і впевненого 
                    у собі чоловіка без відповідної, доречної, модної зачіски?</p>
                  <p>Найточніший спосіб дізнатися вартість послуг перукаря – відвідати салон,
                     поспілкуватися з майстром, обговорити те, які стрижки подобаються, 
                     пасують до зовнішності та іміджу.</p>
                </div>
              </details>
              <details>
                <summary>Фарбування</summary>
                <div className={styles.detailsItems}>
                  {dyeing.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Фарбування -  це ще одна популярна процедура, що дозволяє зробити
                     образ більш яскравим та цікавішим. Майстри салону краси Нія мають 
                     і професійну підготовку і великий досвід в цьому питанні.</p>
                </div>
              </details>
              <details>
                <summary>Хімічна завивка</summary>
                <div className={styles.detailsItems}>
                  {perm.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Хімічна завивка - перукарна процедура формування кучерів і 
                    додаткового об’єму волосся за допомогою моделюючих складів і
                     спеціальних бігуді. Завитки формуються як по всій довжині, так і
                      на кінчиках пасмів, або в прикорневій зоні. Хімічна 
                      завивка відрізняється високою стійкістю і при правильному догляді 
                      тримається до 6 місяців, а іноді навіть довше.</p>
                </div>
              </details>
            </div>
          </div>
        </section>
        <section id="manicure">
          <h2 className="sectionTitle">Манікюр</h2>
          <div className={styles.content}>
            <ProgressiveImage wrapperClassName={styles.contentImageFrame} src={sliderFirstData[1].image} width={sliderFirstData[1].width} height={sliderFirstData[1].height} alt={sliderFirstData[1].title}/>
            <div className={styles.contentDetails}>
              <details>
                <summary>Моделювання</summary>
                <div className={styles.detailsItems}>
                  {modeling.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p></p>
                </div>
              </details>
              <details>
                <summary>Покриття гель лаком</summary>
                <div className={styles.detailsItems}>
                  {varnishCoating.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p></p>
                </div>
              </details>
            </div>
          </div>
        </section>
        <section id="pedicure">
          <h2 className="sectionTitle">Педикюр</h2>
          <div className={styles.content}>
            <ProgressiveImage wrapperClassName={styles.contentImageFrame} src={sliderFirstData[2].image} width={sliderFirstData[2].width} height={sliderFirstData[2].height} alt={sliderFirstData[2].title}/>
            <div className={styles.contentDetails}>
              <details>
                <summary>Педикюр з покриттям</summary>
                <div className={styles.detailsItems}>
                  {pedicureWithCoating.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p></p>
                </div>
              </details>
            </div>
          </div>
        </section>
        <section id="makeup">
          <h2 className="sectionTitle">Візаж</h2>
          <div className={styles.content}>
            <ProgressiveImage wrapperClassName={styles.contentImageFrame} src={sliderFirstData[3].image} width={sliderFirstData[3].width} height={sliderFirstData[3].height} alt={sliderFirstData[3].title}/>
            <div className={styles.contentDetails}>
              <details>
                <summary>Макіяж вечірній</summary>
                <div className={styles.detailsItems}>
                  {eveningMakeup.map((item)=>(
                    <ProgressiveImage key={item.id} className={styles.itemPhoto} src={item.image} alt="Фото послуги салону Нія"/>
                  ))}
                  <p>Професійний візаж здатен не тільки кардинально змінити зовнішній вигляд
                     будь якої жінки — він може подарувати їй можливість сяяти на будь-якому
                      урочистому заході, а також стати зіркою в повсякденному житті.</p>
                </div>
              </details>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Services
